<template>
  <div class="accouny-page mpk-list">
    <AccountPanel title="Lista miejsc powstawania kosztów">
      <div class="table-responsive">
        <table class="table table-striped">
      <thead>
      <tr>
        <th scope="col">nazwa</th>
        <th scope="col">budżet</th>
        <th class="col-sm-1"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in company.mpks">
        <td v-if="!data.edit" scope="col">{{data.mpk.name}}</td>
        <td v-else="" scope="col">
          <input type="text" class="form-control" v-model="data.mpk.name">
        </td>
        <td v-if="!data.edit" scope="col" class="text-center">{{data.mpk.budget.name}}</td>
        <td v-else="" scope="col">
          <select v-model="data.mpk.budget"  id="country" name="country" class="form-control">
            <option v-for="budget in company.budgets.map(b => b.budget)" :value="budget">{{ budget.name }}</option>
          </select>
        </td>
        <td col-sm-1>
          <content-save-icon v-if="data.edit" @click.native="saveMpk(data.mpk)" title="Zapisz"></content-save-icon>
          <pencil-icon v-else="" @click.native="unlockEdit(data)" title="Edytuj"></pencil-icon>
          <delete-icon @click.native="removeMpk(data.mpk)" title="Usuń"></delete-icon>
        </td>
      </tr>
      </tbody>
    </table>
      </div>
    </AccountPanel>
  </div>
</template>

<script>

  import { mapState } from 'vuex';
  import AccountPanel from './AccountPanel.vue'
  import PencilIcon from "vue-material-design-icons/Pencil.vue";
  import DeleteIcon from "vue-material-design-icons/Delete.vue";
  import ContentSaveIcon from "vue-material-design-icons/ContentSave.vue"

  export default {
    components: {
      ContentSaveIcon,
      DeleteIcon,
      PencilIcon,
      AccountPanel
    },
    computed: {
      ...mapState({
        company: state => state.company
      }),
    },

    methods: {
      unlockEdit(data) {
        data.edit = true;
      },
      saveMpk(mpk) {
        this.$store.dispatch('company/editmpk', this.extractedValues(mpk));
      },
      removeMpk(mpk) {
        this.$store.dispatch('company/removempk', this.extractedValues(mpk));
      },
      extractedValues (data) {
        const result = {};
        for (let field in data) {
          result[field] = data[field];
        }
        return result;
      }

    },

    async beforeMount() {
      if (!this.$store.state.user.authorizedUser) {
        this.$router.replace({name: 'mainPage'});
      }

      await this.$store.dispatch('company/mpks');
      await this.$store.dispatch('company/budgets');


    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/MpkList.vue